import ExcelJS from 'exceljs';

/*
  File: excel-download.js
  Fungsi:
  - Ambil data dari tabel HTML
  - Generate file Excel
  - Download langsung di browser
*/
export async function ExcelDown(tableId, fileName = `simPuaData`) { //tanpa extensi .xlsx
  const table = document.getElementById(tableId);
  if (!table) return;

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Data');

  const headers = [];
  table.querySelectorAll('thead th').forEach(th => {
    headers.push(th.innerText.trim());
  });

  worksheet.columns = headers.map(h => ({
    header: h,
    key: h,
    width: 20
  }));

  table.querySelectorAll('tbody tr').forEach(tr => {
    const rowData = {};
    tr.querySelectorAll('td').forEach((td, i) => {
      rowData[headers[i]] = td.innerText.trim();
    });
    worksheet.addRow(rowData);
  });

  const buffer = await workbook.xlsx.writeBuffer();

  const blob = new Blob(
    [buffer],
    { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
  );

  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${fileName}.xlsx`;
  a.click();
  URL.revokeObjectURL(url);
}
